import RadioButton from './RadioButton/RadioButton.vue';
import Vue from 'vue';
import BaseKeyboard from './BaseKeyboard/BaseKeyboard.vue';
import NumKeyboard from '@/components/common/NumKeyboard/NumKeyboard.vue';
import FixedTable from '@/components/common/FixedTable/FixedTable.vue';

Vue.component('RadioButton', RadioButton);
Vue.component('BaseKeyboard', BaseKeyboard);
Vue.component('NumKeyboard', NumKeyboard);
Vue.component('FixedTable', FixedTable);



// WEBPACK FOOTER //
// ./src/components/common/reg.ts